import React from 'react';
import { useAuth } from '../context/AuthContext';
import './PageGate.css';

interface PageGateProps {
  requireAuth?: boolean;
  requirePremium?: boolean;
  children: React.ReactNode;
}

const PageGate: React.FC<PageGateProps> = ({ requireAuth = true, requirePremium = false, children }) => {
  const { isAuthenticated, user } = useAuth();

  const openLogin = () => window.dispatchEvent(new Event('open-login-modal'));

  if (!isAuthenticated) {
    return (
      <div className="gate-wrap">
        <div className="gate-card">
          <div className="gate-icon">🔒</div>
          <h2 className="gate-title">Login to Continue</h2>
          <p className="gate-desc">Sign in to access this section.</p>
          <button className="gate-btn gate-btn--primary" onClick={openLogin}>Sign In</button>
        </div>
      </div>
    );
  }

  if (requirePremium && !user?.isPremium) {
    return (
      <div className="gate-wrap">
        <div className="gate-card">
          <div className="gate-icon">⚡</div>
          <h2 className="gate-title">Pro Access Required</h2>
          <p className="gate-desc">Upgrade to a Pro plan to unlock this section.</p>
          <a className="gate-btn gate-btn--primary" href="/pricing">View Plans</a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default PageGate;
